import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../shared/utils/objects';
import { UserFilter } from '../../../../shared/types/user';
import { ISelect } from '../../../../shared/types/shared';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isAdminUser } from '../../../../shared/utils/user';

export const useUserFilters = (onFilter?: (data: UserFilter) => void) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const profiles: ISelect[] = [
        {
            id: 2,
            name: 'user',
        },
    ];

    if (isAdminUser(type)) {
        profiles.push({
            id: 3,
            name: 'manager',
        });
    }

    const onSubmit = (data: UserFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
        profiles,
    };
};
